import React, { useState, useEffect } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import DataUpload from './DataUpload';
import GolfStats from './GolfStats';
import TrendAnalysis from './TrendAnalysis';
import Recommendations from './Recommendations';
import ClubDistanceBoxPlot from '../Stats/ClubDistanceBoxPlot';
import './Dashboard.css';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await getCurrentUser();
        setUser(userData);
      } catch (error) {
        console.error('Error fetching user', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>RangeDat Dashboard</h1>
        <p>Welcome back, {user?.username || 'Golfer'}!</p>
      </header>

      <div className="dashboard-content">
        <div className="dashboard-section">
          <h2>Upload Range Data</h2>
          <DataUpload />
        </div>

        <div className="dashboard-section">
          <h2>Club Performance Analysis</h2>
          <ClubDistanceBoxPlot />
        </div>

        <div className="dashboard-section">
          <h2>Your Golf Stats</h2>
          <GolfStats />
        </div>

        <div className="dashboard-section">
          <h2>Trend Analysis</h2>
          <TrendAnalysis />
        </div>

        <div className="dashboard-section">
          <h2>Recommendations</h2>
          <Recommendations />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

